export const searchBox = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
}

export const search = {
    width: '440px',
}
